import { isIOS, isTablet } from "react-device-detect";
import { replaceAllData } from "./commonJS";

export const isSeller = () => {
  const url = window.location !== window.parent.location ? document.referrer : document.location.href;
  if (url.includes(SELLER_SITE_PATH)) {
    return true;
  }
  return false;
};

export const WEBSITE_PATH: string = process.env.REACT_APP_WEB_SITEPATH!,
  SELLER_SITE_PATH: string = process.env.REACT_APP_SELLER_SITEPATH!,
  CDN_ONE_FILE_PATH: string = process.env.REACT_APP_CDN_ONE_FILEPATH!,
  IMAGE_RESIZE_PATH: string = process.env.REACT_APP_IMAGE_RESIZEPATH!,
  STORE_BUCKET_NAME: string = process.env.REACT_APP_STORE_BUCKET_NAME!,
  USER_BUCKET_NAME: string = process.env.REACT_APP_USER_BUCKET_NAME!,
  IMG_HAND: string = `${CDN_ONE_FILE_PATH}images/emojis/waving-hand.png`,
  IMG_THUMB: string = `${CDN_ONE_FILE_PATH}images/emojis/thumbs-up.png`,
  SEND_HI_HTML: string = `<img aria-label="👋👋👋" src="${IMG_HAND}" style="width: 24px; height: 24px"/><img src="${IMG_HAND}" style="width: 32px; height: 32px"/><img src="${IMG_HAND}" style="width: 32px; height: 32px"/>`,
  SEND_THUMB_HTML: string = `<img aria-label="👍" src="${IMG_THUMB}" style="width: 32px; height: 32px"/>`,
  MAX_RECORD: number = 10,
  FOLLOWERS_LIMIT: number = 1000,
  MAX_CHARACTER_COUNT: number = 6000,
  CHAT_HEADER_HEIGHT: number = 64,
  CHAT_FOOTER_START_HEIGHT: number = isTablet ? 80 : 64,
  EMOJI_MOBILE_HEIGHT: number = 286,
  SIZE: number = 20,
  SELLER: boolean = isSeller();

export const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export const isNullOrEmpty: any = (val: any) => {
  if (typeof val === "undefined" || val === null) {
    return true;
  }

  if (typeof val === "string" && val.trim() === "") {
    return true;
  }

  if (typeof val === "object" && val.length === 0) {
    return true;
  }

  return false;
};

export const windowPostMessage = (data: any, url: string) => {
  url = window.location !== window.parent.location ? document.referrer : document.location.href;
  window.parent.postMessage(data, url);
};

export const UniqueID = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"
    .replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    })
    .toLowerCase();
};

export const replaceURLsWithTags = (text: string, className?: string) => {
  // Regular expression to match URLs
  var urlRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

  // Replace URLs with anchor tags
  return text.replace(urlRegex, (url) => {
    if (!url.includes(CDN_ONE_FILE_PATH + "images/emojis/emojis")) {
      return `<a class="cur-pot ${className}" data-href="${url}" onClick="onAClick(this)">${url}</a>`;
    } else {
      return url;
    }
  });
};

export const removeSpecialChars = (str?: string) => {
  return str ? str.replace(/[^a-zA-Z ]/g, "") : str;
};

export const returnFormatedStringForChat = (innerHTML?: string) => {
  if (innerHTML !== undefined) return innerHTML.replace(/<br>/g, "").replace(/<div><br><\/div>/g, "");
  // .replace(/\s/g, "");
  else return "";
};

export const returnFormattedMessage = (message: string) => {
  return message
    .replace(/<div><br><\/div>/g, " ")
    .replace(/<div>/g, "")
    .replace(/<\/div>/g, "")
    .replace(/<br>/g, "");
};

export enum UserStats {
  USER_HAS_BLOCKED = 1, // - Logged-in user has blocked the other user,
  NEITHER_USER_IS_FOLLOWING = 2, // - Neither user is following,
  USER_IS_FOLLOWING = 3, // - User is following the logged-in user,
  LOGGED_IN_USER_IS_FOLLOWING = 4, // - Logged-in user is following the other user,
  BOTH_USERS_FOLLOW = 5, // - Both user follow each other,
  USER_IS_ADMIN = 6, // - User is admin,
  USER_HAS_BLOCKED_THE_LOGGED_IN_USER = 7, // - User has blocked the the logged-in user
}

export enum StoreStats {
  NEITHER_USER_IS_FOLLOWING = 0, // - Neither user is following,
  LOGGED_IN_USER_HAS_BLOCKED_THE_STORE = 1, // - Logged-in user has blocked the other user,
  LOGGED_IN_USER_IS_FOLLOWING_THE_STORE = 4, // - Logged-in user is following the other user,
  USER_IS_STORE_ADMIN = 6, // - User is admin,
  STORE_HAS_BLOCKED_THE_USER = 7, // - Logged-in user has blocked the other user,
}

export enum ConversationStatus {
  PENDING = 0,
  APPROVED = 1,
  REJECTED = 2,
}

export enum EntityType {
  USER = 1,
  STORE = 2,
}

export const isValidJSON = (str: string) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const abbreviateNumber = (number: any) => {
  let decPlaces = 1;
  // 2 decimal places => 100, 3 => 1000, etc
  decPlaces = Math.pow(10, decPlaces);

  // Enumerate number abbreviations
  const abbrev = ["K", "M", "B", "T"];

  // Go through the array backwards, so we do the largest first
  for (let i = abbrev.length - 1; i >= 0; i--) {
    // Convert array index to "1000", "1000000", etc
    const size = Math.pow(10, (i + 1) * 3);

    // If the number is bigger or equal do the abbreviation
    if (size <= number) {
      // Here, we multiply by decPlaces, round, and then divide by decPlaces.
      // This gives us nice rounding to a particular decimal place.
      //number = Math.round(number * decPlaces / size) / decPlaces;

      number = (number * decPlaces) / size / decPlaces;

      //var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (decPlaces || -1) + '})?');
      //number = parseInt(number.toString().match(re)[0]);

      // Handle special case where we round up to the next abbreviation
      if (number === 1000 && i < abbrev.length - 1) {
        number = 1;
        i++;
      }

      // Add the letter for the abbreviation
      const re = new RegExp("^-?\\d+(?:.\\d{0," + (1 || -1) + "})?");
      number = number.toString().match(re)[0];

      const arrNum = number.split(".");
      if (arrNum.length === 2) {
        if (arrNum[1] === 0) {
          number = arrNum[0];
        }
      }

      number = number + abbrev[i];

      // We are done... stop
      break;
    }
  }

  return number;
};

export const icon = ({ iconName, iconColor = "icon-primary", iconSize = "size-24", iconStyle, iconCustomClass = "" }: iconProps) => {
  if (isNullOrEmpty(iconName)) return "";
  return (
    <span className={`material-symbols-rounded ${iconColor} ${iconSize} ${iconCustomClass}`} style={iconStyle}>
      {iconName}
    </span>
  );
};

export const replaceImgWithAttrValue = (htmlString: string) => {
  // This regex matches <img> tags and captures the src attribute
  const regex = /<img[^>]+aria-label="([^"]+)"[^>]*>/g;
  return htmlString.replace(regex, "$1");
};

export const objReactions: any = [
  {
    label: "Like",
    node: isIOS ? (
      <img
        aria-label="👍"
        srcSet=""
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgMBAhS+BpQAAAAASUVORK5CYII="
        width="32"
        height="32"
        style={{ objectFit: "none", backgroundSize: "6100% 6100%", backgroundImage: "url(https://statics3.dev.trepup.com/images/emojis/emojis-64.png)", backgroundPosition: "20% 80%" }}
      />
    ) : (
      <img aria-label="👍" src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" width="32" height="32" style={{ backgroundSize: "6100% 6100%", backgroundImage: "url(https://statics3.dev.trepup.com/images/emojis/emojis-64.png)", backgroundPosition: "20% 80%" }} />
    ),
    key: "1",
    nodeString: `<img aria-label="👍" ${isIOS ? `srcSet="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgMBAhS+BpQAAAAASUVORK5CYII="` : `src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="`} width="16" height="16" style="${
      isIOS ? `object-fit: none;` : ``
    } background-size: 6100% 6100%; background-image: url(https://statics3.dev.trepup.com/images/emojis/emojis-64.png); background-position: 20% 80%" />`,
  },
  {
    label: "Love",
    node: isIOS ? (
      <img
        aria-label="🧟"
        srcSet=""
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgMBAhS+BpQAAAAASUVORK5CYII="
        width="32"
        height="32"
        style={{ objectFit: "none", backgroundSize: "6100% 6100%", backgroundImage: "url(https://statics3.dev.trepup.com/images/emojis/emojis-64.png)", backgroundPosition: "88.3333% 25%" }}
      />
    ) : (
      <img aria-label="🧟" src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" width="32" height="32" style={{ backgroundSize: "6100% 6100%", backgroundImage: "url(https://statics3.dev.trepup.com/images/emojis/emojis-64.png)", backgroundPosition: "88.3333% 25%" }} />
    ),
    key: "2",
    nodeString: `<img aria-label="🧟" ${isIOS ? `srcSet="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgMBAhS+BpQAAAAASUVORK5CYII="` : `src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="`} width="16" height="16" style="${
      isIOS ? `object-fit: none;` : ``
    } background-size: 6100% 6100%; background-image: url(https://statics3.dev.trepup.com/images/emojis/emojis-64.png); background-position: 88.3333% 25%" }} />`,
  },
  {
    label: "Haha",
    node: isIOS ? (
      <img
        aria-label="😅"
        srcSet=""
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgMBAhS+BpQAAAAASUVORK5CYII="
        width="32"
        height="32"
        style={{ objectFit: "none", backgroundSize: "6100% 6100%", backgroundImage: "url(https://statics3.dev.trepup.com/images/emojis/emojis-64.png)", backgroundPosition: "53.3333% 43.3333%" }}
      />
    ) : (
      <img aria-label="😅" src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" width="32" height="32" style={{ backgroundSize: "6100% 6100%", backgroundImage: "url(https://statics3.dev.trepup.com/images/emojis/emojis-64.png)", backgroundPosition: "53.3333% 43.3333%" }} />
    ),
    key: "3",
    nodeString: `<img aria-label="😅" ${isIOS ? `srcSet="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgMBAhS+BpQAAAAASUVORK5CYII="` : `src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="`} width="16" height="16" style="${
      isIOS ? `object-fit: none;` : ``
    } background-size: 6100% 6100%; background-image: url(https://statics3.dev.trepup.com/images/emojis/emojis-64.png); background-position: 53.3333% 43.3333%" }} />`,
  },
  {
    label: "Wow",
    node: isIOS ? (
      <img
        aria-label="😮"
        srcSet=""
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgMBAhS+BpQAAAAASUVORK5CYII="
        width="32"
        height="32"
        style={{ objectFit: "none", backgroundSize: "6100% 6100%", backgroundImage: "url(https://statics3.dev.trepup.com/images/emojis/emojis-64.png)", backgroundPosition: "55% 11.6667%" }}
      />
    ) : (
      <img aria-label="😮" src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" width="32" height="32" style={{ backgroundSize: "6100% 6100%", backgroundImage: "url(https://statics3.dev.trepup.com/images/emojis/emojis-64.png)", backgroundPosition: "55% 11.6667%" }} />
    ),
    key: "4",
    nodeString: `<img aria-label="😮" ${isIOS ? `srcSet="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgMBAhS+BpQAAAAASUVORK5CYII="` : `src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="`} width="16" height="16" style="${
      isIOS ? `object-fit: none;` : ``
    } background-size: 6100% 6100%; background-image: url(https://statics3.dev.trepup.com/images/emojis/emojis-64.png); background-position: 55% 11.6667%" }} />`,
  },
  {
    label: "Sad",
    node: isIOS ? (
      <img
        aria-label="😬"
        srcSet=""
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgMBAhS+BpQAAAAASUVORK5CYII="
        width="32"
        height="32"
        style={{ objectFit: "none", backgroundSize: "6100% 6100%", backgroundImage: "url(https://statics3.dev.trepup.com/images/emojis/emojis-64.png)", backgroundPosition: "55% 6.66667%" }}
      />
    ) : (
      <img aria-label="😬" src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" width="32" height="32" style={{ backgroundSize: "6100% 6100%", backgroundImage: "url(https://statics3.dev.trepup.com/images/emojis/emojis-64.png)", backgroundPosition: "55% 6.66667%" }} />
    ),
    key: "5",
    nodeString: `<img aria-label="😬" ${isIOS ? `srcSet="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgMBAhS+BpQAAAAASUVORK5CYII="` : `src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="`} width="16" height="16" style="${
      isIOS ? `object-fit: none;` : ``
    } background-size: 6100% 6100%; background-image: url(https://statics3.dev.trepup.com/images/emojis/emojis-64.png); background-position: 55% 6.66667%" }} />`,
  },
  {
    label: "Angry",
    node: isIOS ? (
      <img
        aria-label="😠"
        srcSet=""
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgMBAhS+BpQAAAAASUVORK5CYII="
        width="32"
        height="32"
        style={{ objectFit: "none", backgroundSize: "6100% 6100%", backgroundImage: "url(https://statics3.dev.trepup.com/images/emojis/emojis-64.png)", backgroundPosition: "53.3333% 88.3333%" }}
      />
    ) : (
      <img aria-label="😠" src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" width="32" height="32" style={{ backgroundSize: "6100% 6100%", backgroundImage: "url(https://statics3.dev.trepup.com/images/emojis/emojis-64.png)", backgroundPosition: "53.3333% 88.3333%" }} />
    ),
    key: "6",
    nodeString: `<img aria-label="😠" ${isIOS ? `srcSet="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgMBAhS+BpQAAAAASUVORK5CYII="` : `src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="`} width="16" height="16" style="${
      isIOS ? `object-fit: none;` : ``
    } background-size: 6100% 6100%; background-image: url(https://statics3.dev.trepup.com/images/emojis/emojis-64.png); background-position: 53.3333% 88.3333%" }} />`,
  },
  {
    label: "All",
    node: icon({ iconName: "add_circle", iconColor: "icon-primary", iconCustomClass: "pad-t-8" }),
    key: "7",
  },
];

export const hasDayChanged = (date1: any, date2: any) => {
  // Extract day, month, and year from both dates
  const day1 = date1.getDate();
  const month1 = date1.getMonth();
  const year1 = date1.getFullYear();

  const day2 = date2.getDate();
  const month2 = date2.getMonth();
  const year2 = date2.getFullYear();

  // Check if the day, month, or year is different
  return day1 !== day2 || month1 !== month2 || year1 !== year2;
};

export const setShortName = (name: string) => {
  if (isNullOrEmpty(name)) return "";
  var fullName = name.split(" "),
    firstName = fullName[0],
    lastName = fullName[fullName.length - 1];
  return `${firstName.substring(0, 1)} ${lastName}`;
};

export const restrictMaxLength = (e: any, keyboardEvent: boolean) => {
  let within: boolean = true;
  const msgBox: any = document.getElementById("messageBox");
  if (msgBox) {
    const trimmedHtml: any = returnFormatedStringForChat(msgBox.innerHTML);
    let imageCount = trimmedHtml.split("<imgsrc").length - 1;
    let newString: string = replaceAllData(msgBox.innerText, "\n", "");
    let count = newString.length + imageCount;
    if (keyboardEvent) {
      if (
        count >= MAX_CHARACTER_COUNT &&
        !(
          e.which === 8 /* BACKSPACE */ ||
          e.which === 35 /* END */ ||
          e.which === 36 /* HOME */ ||
          e.which === 37 /* LEFT */ ||
          e.which === 38 /* UP */ ||
          e.which === 39 /* RIGHT*/ ||
          e.which === 40 /* DOWN */ ||
          e.which === 46 /* DEL*/ ||
          (e.ctrlKey === true && e.which === 65) /* CTRL + A */ ||
          (e.ctrlKey === true && e.which === 88) /* CTRL + X */ ||
          (e.ctrlKey === true && e.which === 67) /* CTRL + C */ ||
          (e.ctrlKey === true && e.which === 86) /* CTRL + V */ ||
          (e.ctrlKey === true && e.which === 90)
        ) /* CTRL + Z */
      ) {
        within = false;
      }
    } else {
      if (count >= MAX_CHARACTER_COUNT) {
        within = false;
      }
    }
  }
  return within;
};

export const detectURL = (inputString: string) => {
  const urlRegex = /(https?:\/\/[^\s/$.?#].[^\s]*\.[a-z]{2,})/gi;
  const urls = inputString.match(urlRegex);
  return urls || [];
};

interface iconProps {
  iconName: string;
  iconColor?: string;
  iconSize?: string;
  iconStyle?: any;
  iconCustomClass?: string;
}

export const replaceEmojiSizeForInbox = (message: string) => {
  message = replaceAllData(message, `width="48"`, `width="20"`);
  message = replaceAllData(message, `width="36"`, `width="20"`);
  message = replaceAllData(message, `width="32"`, `width="20"`);
  message = replaceAllData(message, `width="24"`, `width="20"`);
  message = replaceAllData(message, `height="48"`, `height="20"`);
  message = replaceAllData(message, `height="36"`, `height="20"`);
  message = replaceAllData(message, `height="32"`, `height="20"`);
  message = replaceAllData(message, `height="24"`, `height="20"`);
  message = replaceAllData(message, `32px`, `20px`);
  return message;
};

export const HtmlEncode = (val: string) => {
  if (isNullOrEmpty(val)) {
    return val;
  }
  return val.replace(/&/gi, "&amp;").replace(/</gi, "&lt;").replace(/>/gi, "&gt;").replace(/"/gi, "&quot;").replace(/'/gi, "&#x27;").replace(/\//gi, "&#x2F;");
};

export const HtmlDecode = (val: string) => {
  if (isNullOrEmpty(val)) {
    return val;
  }
  return val
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#x27;/gi, "'")
    .replace(/&#x2F;/gi, "/")
    .replace(/&amp;/gi, "&");
};

export const extractImgTags = (htmlString: string) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;
  const imgTags = tempDiv.querySelectorAll("img");
  return Array.from(imgTags);
};